import { IApplicationDetails } from 'features/ApplicationForm/types';
import { DevelopmentCommunityGoals } from './DevelopmentCommunityGoals';
import { FBDIGoals } from './FBDIGoals';
import { HowInfo } from './HowInfo';
import { HowStructure } from './HowStructure';
import { ProjectInfo } from './ProjectInfo';

export default function FBDIApplicationDetails({
  applicationData,
  files,
}: IApplicationDetails) {
  return (
    <>
      <HowInfo howInfo={applicationData.howInfo} />
      <HowStructure howStructure={applicationData.howStructure} />
      <ProjectInfo projectInfo={applicationData.projectInfo} />
      <DevelopmentCommunityGoals
        developmentCommunityGoals={applicationData.developmentAndCommunityGoals}
      />
      <FBDIGoals fbdiGoals={applicationData.fbdiGoals} />
    </>
  );
}
